import api from '@/client/core/api'
import { PostTagsBulkAssignBody } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * POST /twitter_benchmark_campaign_posts/tags/bulk-assign
 */
export async function postTwBenchmarkTagsBulkAssign(
  groupId: number,
  body: PostTagsBulkAssignBody
): Promise<TwBenchmarkApiResult<boolean>> {
  const response = await api.post<TwBenchmarkApiResponse<boolean>>(
    '/twitter_benchmark_campaign_posts/tags/bulk-assign',
    body,
    { params: { groupId } }
  )

  return handleApiResponse<boolean>(response)
}
